/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Edit_Search_HintInputs */



/**
* | output |
* | --- |
* | "Search and select a card to add it to the deck" |
*
* @param {Deck_Edit_Search_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_edit_search_hint = /** @type {((inputs?: Deck_Edit_Search_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Edit_Search_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recherchez et sélectionnez une carte pour l'ajouter au deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Busque y seleccione una carta para agregarla al deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pesquise e selecione uma carta para adicionar ao deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca e seleziona una carta da aggiungere al deck")
	return /** @type {LocalizedString} */ ("Search and select a card to add it to the deck")
});